import { render, staticRenderFns } from "./addcard.vue?vue&type=template&id=49e5b338&scoped=true"
import script from "./addcard.vue?vue&type=script&lang=js"
export * from "./addcard.vue?vue&type=script&lang=js"
import style0 from "./addcard.vue?vue&type=style&index=0&id=49e5b338&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e5b338",
  null
  
)

export default component.exports